
$("a[rel=popover]").popover
  trigger: 'hover'
  html: true

$(".formats a").popover
  title: "Abrufen als JSON"
  content: "Du hast eine Idee die weitere Verwendung dieser Daten oder dir fehlt eine Funktion? Dann schreib uns einfach an!"
